// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.help-tooltip {\n  border: none !important;\n  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25);\n}\n", ""]);
// Exports
module.exports = exports;
